import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrement du Service Worker pour PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✓ Service Worker enregistré:', registration.scope);
      })
      .catch((error) => {
        console.log('✗ Erreur Service Worker:', error);
      });
  });
}

// Gestion de l'installation PWA sur iOS
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  console.log('PWA peut être installée');
});

// Détection iOS
const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

// Message d'installation pour iOS
if (isIos() && !window.navigator.standalone) {
  console.log('📱 Sur iOS - Installer via Safari: Partager > Sur l\'écran d\'accueil');
}